import produce from 'immer';
import {
  REQUEST_FETCH_WORKFLOW_PRODUCT,
  REQUEST_WORKFLOW,
  REQUEST_WORKFLOWS,
  REQUEST_WORKFLOWS_FILTER,
  REQUEST_COMPANY_WORKFLOW,
} from './constants';
import { REQUEST_DATA_RESULT } from '../../containers/App/constants';

export const initialState = {
  workflows: [],
  workflowsById: {},
  filter: {
    searchString: null,
    offset: 0,
  },
  itemsCount: 0,
};

export const workflowsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case REQUEST_WORKFLOWS_FILTER:
        if (action.name) {
          if (action.name === 'clear') {
            draft.filter = {
              searchString: null,
              offset: 0,
            };
          } else {
            if (action.value === null) {
              delete draft.filter[action.name];
            } else {
              draft.filter[action.name] = action.value;
            }
            //reset offset
            if (action.name !== 'offset') draft.filter.offset = 0;
          }
        }
        break;
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_COMPANY_WORKFLOW:
            draft.companyWorkflow = action.result;
            break;
          case REQUEST_WORKFLOWS:
            draft.workflows = action.result.items;
            draft.paginator = action.result.paginator;
            draft.itemsCount = action.result.paginator.itemsCount;
            draft.workflows.forEach(w => {
              if (!draft.workflowsById[w.id]) draft.workflowsById[w.id] = w;
            });
            break;
          case REQUEST_WORKFLOW:
            // draft.workflow = action.result;
            try {
              draft.workflowsById[action.workflowId] = action.result;
            } catch (e) {
              console.error(e);
            }
            break;
          case REQUEST_FETCH_WORKFLOW_PRODUCT:
            draft.workflowProduct = action.result;
        }
    }
  });
